import { useMemo } from "react"
import PropTypes from "prop-types"
import { ListItemButton, ListItemAvatar, ListItemText, Avatar, Checkbox } from "@mui/material"
import { UNIVERSAL_SEARCH_RESULT } from "helpers/shapes"
import { getHighlightedText } from "../helpers"
import { SecondaryText } from "./secondary-text"
import { SecondaryIcon } from "./secondary-icon"

export default function SearchResult({ item, disableResult, handleAction, multiSelect, resultSelected, value }) {
  const disabled = useMemo(() => disableResult(item) || (!item.mainAction && !item.secondaryAction), [item, disableResult])
  return <ListItemButton
    data-testid={item.description}
    className="unified-search-item"
    classes={{
      root: !item.mainAction && "no-main-action",
    }}
    tabIndex={-1}
    disabled={disabled}
    onClick={item.mainAction ? () => handleAction(item.mainAction, item.noDispatch, null, item) : null}
    selected={item.selected}
  >
    <ListItemAvatar>
      <Avatar className={`item-type-${item.iconType}`}>
        {item.icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText classes={{ primary: "search-result-description" }} primary={getHighlightedText(item.description, value)} secondary={<SecondaryText {...item} value={value} />} />
    <SecondaryIcon item={item} handleAction={handleAction} />
    {multiSelect && <Checkbox disabled={disabled} checked={resultSelected(item)} />}
  </ListItemButton>
}

SearchResult.propTypes = {
  item: PropTypes.shape(UNIVERSAL_SEARCH_RESULT).isRequired,
  disableResult: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  multiSelect: PropTypes.bool.isRequired,
  resultSelected: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}
